namespace $ { $mol_style_attach( "mol/button/major/major.view.css",
 "[mol_button_major][disabled] {\n\topacity: .5;\n\tfilter: grayscale();\n}\n"
) }